/**
 * `skinMetricsFrom` (W1-08 formats-legacy-respack; contract formats/respack/types.ts; skin-and-assets.md S§2-S§4):
 * the pure numbers the engine needs to build note quads and hit effects, from a validated ResPackInfo and the
 * decoded image sizes. The two hold-body slots are the middle slices of hold.png / hold_mh.png between the tail
 * (top, holdAtlas[0] px) and the head (bottom, holdAtlas[1] px): the separate textures `holdRepeat` tiles.
 */

import type { SkinMetrics } from '../../core/engine/types';
import { parsePhiraColor } from './color';
import type { SkinMetricsFromFn } from './types';

/** Size of the body slice of a hold image: [width, height - tail - head] (never negative). */
export function holdBodySize(
  size: readonly [number, number],
  atlas: readonly [tailPx: number, headPx: number],
): readonly [number, number] {
  return [size[0], Math.max(0, size[1] - atlas[0] - atlas[1])];
}

export const skinMetricsFrom: SkinMetricsFromFn = (info, sizes): SkinMetrics => ({
  tex: {
    click: sizes.click,
    hold: sizes.hold,
    flick: sizes.flick,
    drag: sizes.drag,
    click_mh: sizes.click_mh,
    hold_mh: sizes.hold_mh,
    flick_mh: sizes.flick_mh,
    drag_mh: sizes.drag_mh,
    holdBody: holdBodySize(sizes.hold, info.holdAtlas),
    holdBodyMh: holdBodySize(sizes.hold_mh, info.holdAtlasMH),
  },
  holdAtlas: info.holdAtlas,
  holdAtlasMH: info.holdAtlasMH,
  hitFx: info.hitFx,
  hitFxDuration: info.hitFxDuration,
  hitFxScale: info.hitFxScale,
  hitFxRotate: info.hitFxRotate,
  hitFxTinted: info.hitFxTinted,
  hideParticles: info.hideParticles,
  holdKeepHead: info.holdKeepHead,
  holdRepeat: info.holdRepeat,
  holdCompact: info.holdCompact,
  colorPerfect: parsePhiraColor(info.colorPerfect),
  colorGood: parsePhiraColor(info.colorGood),
});
